import { Component, inject } from '@angular/core';
import { BadgeComponent, ButtonComponent, CardComponent, IconComponent, MenuContentComponent, MenuDirective, ModalService, NotificationService } from '@pansa/ui';
import { GroupColorPipe } from '@app/features/groups/pipes/group-color.pipe';
import { Router } from '@angular/router';
import { AuthorizedEntityDetailsService } from '../../services/authorized-entity-details.service';
import { AuthorizedEntityService } from '../../services/authorized-entity.service';
import { tap } from 'rxjs';

@Component({
  selector: 'rqa-authorized-entity-details',
  templateUrl: './authorized-entity-details.component.html',
  styleUrls: ['./authorized-entity-details.component.scss'],
  imports: [
    CardComponent,
    ButtonComponent,
    IconComponent,
    BadgeComponent,
    GroupColorPipe,
    MenuContentComponent,
    MenuDirective
  ]
})
export class AuthorizedEntityDetailsComponent {
  readonly authorizedEntityDetailsService = inject(AuthorizedEntityDetailsService);
  private router = inject(Router);
  private modalService = inject(ModalService);
  private authorizedEntityService = inject(AuthorizedEntityService);
  private notificationService = inject(NotificationService);
  authorizedEntity = this.authorizedEntityDetailsService.authorizedEntity;

  onAddPerson(entityId: string | undefined): void {
    this.router.navigate([`/authorized-entity/${entityId}/add-person`]);
  }

  onEdit(entityId: string | undefined): void {
    this.router.navigate(['/authorized-entity/edit', entityId]);
  }

  onDelete(): void {
    this.modalService.openModal({
      type: 'warning',
      destructive: true,
      title: `Czy chcesz usunąć podmiot ${this.authorizedEntity()?.name}`,
      subTitle: 'Usunięcie podmiotu jest trwałe',
      submitText: 'Usuń podmiot',
      cancelText: 'Anuluj',
      onSubmit: () => this.deleteAuthorizedEntity()
    });
  }

  private deleteAuthorizedEntity() {
    const entityId = this.authorizedEntity()?.uuid as string;
    this.authorizedEntityService
      .deleteAuthorizedEntity(entityId)
      .pipe(
        tap(() => {
          this.notificationService.success({
            title: 'Sukces',
            subTitle: 'Usunięto podmiot uprawniony'
          });
          this.authorizedEntityDetailsService.close();
          this.authorizedEntityService.refreshAuthorizedEntity();
        })
      )
      .subscribe();
  }
}
